import HttpClient from '@/services/http-client'

class RegulatoryOrdinanceService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/regulatory-ordinances/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/regulatory-ordinances', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/regulatory-ordinances', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/regulatory-ordinances/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/regulatory-ordinances/' + id)
  }
}

export default () => new RegulatoryOrdinanceService()
